var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.212 1.673a7.119 7.119 0 01-2.026.537A3.542 3.542 0 0016.739.254a7.083 7.083 0 01-2.241.86 3.53 3.53 0 00-6.013 3.219A10.027 10.027 0 011.215.647a3.53 3.53 0 001.09 4.707 3.471 3.471 0 01-1.612-.44v.042a3.53 3.53 0 002.827 3.46 3.53 3.53 0 01-1.59.06 3.525 3.525 0 003.293 2.45 7.088 7.088 0 01-4.38 1.51c-.281 0-.563-.016-.843-.048A10.006 10.006 0 005.406 14c6.491 0 10.038-5.374 10.038-10.038v-.457a7.039 7.039 0 001.768-1.832z"
  })));
}

export default SvgTwitter;